import React, { Component } from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import Sidebar from '../../common/Sidebar';
import Topbar from '../../common/Topbar';
import ProfileTopMenu from "./topmenu";
import { getLocalStorageVariables, getThemeSettingsVariables, handleTokenExpiry, hasFeatureAccess, isEmptyArray } from '../../common/Global/commonFunctions';
import { AssigmentDetailsIconLayout, FilterCheckBox, PageSaveButton } from '../../common/Global/globalStyles.style';
import * as Constants from '../../common/Global/constants';
import AlertDialog from '../../common/AlertDialog';
import RegularDropDown from '../../common/DropdownMenus/RegularDropdown';

let userDetails = getLocalStorageVariables();
let themeSettings = getThemeSettingsVariables();
let defaultDashboardPlaceholder = "Select Default Dashboard";
class UserSetting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAlertDialogInfo:false,  
            alertDialogMessageInfo:"",
            notificationList:[],
            componentDidMountFlag:false,
            departmentList:[],
            editDashboard: false,
            dashboardClientId: "",
            selectedDashboardName: defaultDashboardPlaceholder,
            notificationPlanningScheduling: false,
            notificationAssignmentRelated: false,
            notificationReviewMasterDocuments: false,
            notificationFollowUp: false,
            notificationOthers: false,
            showNotificationBtnLoader: false,
        }
        userDetails = getLocalStorageVariables();
        themeSettings = getThemeSettingsVariables();
    }

    componentDidMount(){
        this.getInitData();
    }

    handleNotificationCheckBox = (e) => {
        const { name, checked } = e.target;
        this.setState({ [name]: checked });
    }

    defaultDashboardDropdownClick = (item) => {
        this.setState({
            dashboardClientId: item.dashboardClientId,
            selectedDashboardName: item.dashboardClientName,
            // editDashboard: false
        });
    }

    clearSelectedValue = () => {
        this.setState({
            dashboardClientId: "",
            selectedDashboardName: defaultDashboardPlaceholder,
            editDashboard: false
        });
    }

    /******************** API CALLS **********************/
    getInitData = () => {
        this.setState({
            showLoader:true,
        });
        Promise.all([
            fetch(Constants.DashboardsDefaultCurrent,
            {
                method: "POST",
                mode: 'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken
                })
            }),
            fetch(Constants.ProfileEmailNotification+"/"+userDetails.userId,
            {
                method: "POST",
                mode: 'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken
                })
            }),
            fetch(Constants.GetUserMenu,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                })
            })
        ])
        .then(([defaultRes, emailRes, menuRes]) => {
            return Promise.all([
                defaultRes.json(), emailRes.json(), menuRes.json()
            ])
        })
        .then(([defaultRes, emailRes, menuRes]) => {
            let currentDefaultDashboard = [];
            let departments = [];
            let clientId = "";
            let selectedDashboardName = "";
            let dashboardClientId = "";
            
            if(handleTokenExpiry(defaultRes.responseCode)) return;
            else if(defaultRes.responseCode === Constants.CODE_SUCCESS){
                currentDefaultDashboard = defaultRes.data.currentDefaultDashboard;
                if(currentDefaultDashboard) {
                    selectedDashboardName = currentDefaultDashboard.dashboardClientName;
                    dashboardClientId = currentDefaultDashboard.dashboardClientId;
                }else{
                    selectedDashboardName = "Ongoing Assignment"
                }
            }else{
            }

            let notificationList = [...this.state.notificationList];
            let notificationPlanningScheduling = false;
            let notificationAssignmentRelated = false;
            let notificationReviewMasterDocuments = false;
            let notificationFollowUp = false;
            let notificationOthers = false;
            if(handleTokenExpiry(emailRes.responseCode)) return;
            else if(emailRes.responseCode === Constants.CODE_SUCCESS){
                let notificationData = emailRes.data;
                if(!isEmptyArray(notificationData)){
                    notificationData.map(item => {
                        notificationList.push(item.notificationType);
                        if(item.notificationType === "Planning & Scheduling") notificationPlanningScheduling = true;
                        if(item.notificationType === "Assignment Related") notificationAssignmentRelated = true;
                        if(item.notificationType === "Review of Master Documents") notificationReviewMasterDocuments = true;
                        if(item.notificationType === "Follow Up") notificationFollowUp = true;
                        if(item.notificationType === "Others") notificationOthers = true;
                    })
                }
            }else{
            }

            if(handleTokenExpiry(menuRes.responseCode)) return;
            else if(menuRes.responseCode === Constants.CODE_SUCCESS){
                departments = menuRes.data.departments;
                clientId = menuRes.data.user.clientId;
            }else{
            }

            this.setState({
                notificationList:notificationList,
                notificationPlanningScheduling,
                notificationAssignmentRelated,
                notificationReviewMasterDocuments,
                notificationFollowUp,
                notificationOthers,
                selectedDashboardName:selectedDashboardName,
                dashboardClientId:dashboardClientId,
                departments:departments,
                clientId:clientId
            },() => {
                this.getDashboard()
            })
        });
    }

    getDashboard = () => {
        const departmentIds = this.state.departments.map(item => item.departmentId);
        // fetch(Constants.Dashboards+"/"+this.state.clientId,
        fetch(Constants.UsersDashboards,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                pageNo:1,
                search:"",
                resultsize:100,
                status:'Active',
                sort:"",
                sortDir:"",
                departmentIdList:JSON.stringify(departmentIds)
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                this.setState({
                    showLoader:false,
                    componentDidMountFlag:true,
                    datalist:data.data.userDashboardList,
                    totalCount:data.data.totalCount,
                    apiSearchKey:this.state.clientSearchkey
                })
            }else{
                this.setState({
                    datalist:[],
                    totalCount:0,
                    showLoader:false,
                    componentDidMountFlag:true,
                    apiSearchKey:this.state.clientSearchkey,
                })
            }
        });
    }

    saveSettings = () => {
        this.setState({
            showBtnLoader:true
        })

        fetch(Constants.DashboardsDefault,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                dashboardClientId:this.state.dashboardClientId
            })
        })
        .then(response => { return response.json(); })
        .then(data => {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                this.setState({
                    showBtnLoader:false
                }, () => {
                    this.dashboardsDefaultCurrent();
                })
            }
        });
    }

    dashboardsDefaultCurrent = () => {
        fetch(Constants.DashboardsDefaultCurrent,
        {
            method: "POST",
            mode: 'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                let currentDefaultDashboard = data.data.currentDefaultDashboard;
                let selectedDashboardName = currentDefaultDashboard ? currentDefaultDashboard.dashboardClientName : defaultDashboardPlaceholder;
                let dashboardClientId = currentDefaultDashboard ? currentDefaultDashboard.dashboardClientId : "";

                this.setState({
                    selectedDashboardName:selectedDashboardName,
                    dashboardClientId:dashboardClientId,
                    editDashboard: false
                })
            }
        })
    }

    getEmailNotification = () => {
        this.setState({
            showLoader:true,
        });
        fetch(Constants.ProfileEmailNotification+"/"+userDetails.userId,
        {
            method: "POST",
            mode: 'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                let notificationData = data.data;
                let notificationList = [];
                let notificationPlanningScheduling = false;
                let notificationAssignmentRelated = false;
                let notificationReviewMasterDocuments = false;
                let notificationFollowUp = false;
                let notificationOthers = false;
                if(!isEmptyArray(notificationData)){
                    notificationData.map(item => {
                        notificationList.push(item.notificationType);
                        if(item.notificationType === "Planning & Scheduling") notificationPlanningScheduling = true;
                        if(item.notificationType === "Assignment Related") notificationAssignmentRelated = true;
                        if(item.notificationType === "Review of Master Documents") notificationReviewMasterDocuments = true;
                        if(item.notificationType === "Follow Up") notificationFollowUp = true;
                        if(item.notificationType === "Others") notificationOthers = true;
                    })
                }
                this.setState({
                    notificationList,
                    notificationPlanningScheduling,
                    notificationAssignmentRelated,
                    notificationReviewMasterDocuments,
                    notificationFollowUp,
                    notificationOthers,
                    showLoader:false,
                    componentDidMountFlag:true,
                })
            }else{
                this.setState({
                    datalist:[],
                    showLoader:false,
                    componentDidMountFlag:true,
                    showAlertDialogInfo:true,
                    alertDialogMessageInfo:data.responseMessage,
                })
            }
        });
    }

    saveNotificationSettings = () => {
        const notificationList = [];
        if(this.state.notificationPlanningScheduling) notificationList.push("Planning & Scheduling");
        if(this.state.notificationAssignmentRelated) notificationList.push("Assignment Related");
        if(this.state.notificationReviewMasterDocuments) notificationList.push("Review of Master Documents");
        if(this.state.notificationFollowUp) notificationList.push("Follow Up");
        if(this.state.notificationOthers) notificationList.push("Others");

        this.setState({ showNotificationBtnLoader: true, notificationList });
        fetch(Constants.ProfileEmailNotification,
        {
            method: "POST",
            mode: 'cors',
            body: new URLSearchParams({
                email: userDetails.email,
                accessToken: userDetails.accessToken,
                notificationList: JSON.stringify(notificationList),
            })
        })
        .then(response => { return response.json(); })
        .then(data => {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                this.setState({ showNotificationBtnLoader: false },() => {
                    this.getEmailNotification();
                });
            }
        });
    }

    /******************** API CALLS END HERE*********************/

    render() {
        return(
            <Router>
                <main className="main-dashboard">
                    <section className="dashboard-bg">
                        <Sidebar />
                        <div className="dashboard-right-bg position-relative">
                            <div className="dashboard-wrapper">
                                <Topbar />
                                {
                                    this.state.showLoader &&
                                    <div class="loader"></div>
                                }
                                {this.state.componentDidMountFlag &&
                                    <div className="body-wrapper">
                                        <div className="profile-outer-layout">
                                            <div className="row custom-row">
                                                <div className="col-md-6 custom-col">
                                                    <div className="card-col">
                                                        <ProfileTopMenu
                                                            themeSettings={themeSettings}
                                                        />
                                                        <div style={{marginTop: '24px'}}>
                                                            <h6>Select Default Dashboard</h6>
                                                            <div style={{display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px'}}>
                                                                {!this.state.editDashboard ? (
                                                                    <div style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        width: '100%'
                                                                    }}>
                                                                        <p style={{width: 250,
                                                                            height: 38,
                                                                            fontSize: 14,
                                                                            fontWeight: 'normal',
                                                                            margin: 0,
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            textAlign: 'center'
                                                                        }}
                                                                            >
                                                                            {this.state.selectedDashboardName}
                                                                        </p>
                                                                        <AssigmentDetailsIconLayout themeSettings={themeSettings}>
                                                                            <span className="material-icons" style={{fontSize: 23}} 
                                                                                onClick={() => this.setState({editDashboard: true})}>edit</span>
                                                                        </AssigmentDetailsIconLayout>
                                                                    </div>
                                                                ) : (
                                                                    <>
                                                                        <RegularDropDown
                                                                            placeholder={this.state.selectedDashboardName}
                                                                            dropdownArr={this.state.datalist || []}
                                                                            labelParam="dashboardClientName"
                                                                            onDropDownItemClick={this.defaultDashboardDropdownClick}
                                                                            defaultPlaceholderDropDown={defaultDashboardPlaceholder}
                                                                            clearSelectedValue={()=>this.clearSelectedValue()}
                                                                        />
                                                                        {/* <AssigmentDetailsIconLayout themeSettings={themeSettings}>
                                                                            <span className="material-icons" style={{fontSize: 23}} 
                                                                                onClick={() => this.setState({editDashboard: false})}>close</span>
                                                                        </AssigmentDetailsIconLayout> */}
                                                                    </>
                                                                )}
                                                            </div>
                                                            <div style={{textAlign: 'center', marginTop: '12px'}}>
                                                                <PageSaveButton themeSettings={themeSettings}
                                                                    onClick={this.saveSettings} type="button" className="common-save">
                                                                    {this.state.showBtnLoader ? <div className="loader-btn mt-2"></div> : 'Save'}
                                                                </PageSaveButton>
                                                            </div>
                                                            {hasFeatureAccess(Constants.FEATURE_EMAIL_NOTIFICATION) &&
                                                            <>
                                                                <h6 style={{marginTop:20}}>Email Notification Settings</h6>
                                                                <div style={{display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '20px'}}>
                                                                    <FilterCheckBox themeSettings={themeSettings}>
                                                                        <input
                                                                            type="checkbox"
                                                                            name="notificationPlanningScheduling"
                                                                            id="notificationPlanningScheduling"
                                                                            onChange={this.handleNotificationCheckBox}
                                                                            checked={this.state.notificationPlanningScheduling}
                                                                        />
                                                                        <label htmlFor="notificationPlanningScheduling">Planning &amp; Scheduling</label>
                                                                    </FilterCheckBox>
                                                                    <FilterCheckBox themeSettings={themeSettings}>
                                                                        <input
                                                                            type="checkbox"
                                                                            name="notificationAssignmentRelated"
                                                                            id="notificationAssignmentRelated"
                                                                            onChange={this.handleNotificationCheckBox}
                                                                            checked={this.state.notificationAssignmentRelated}
                                                                        />
                                                                        <label htmlFor="notificationAssignmentRelated">Assignment Related</label>
                                                                    </FilterCheckBox>
                                                                    <FilterCheckBox themeSettings={themeSettings}>
                                                                        <input
                                                                            type="checkbox"
                                                                            name="notificationReviewMasterDocuments"
                                                                            id="notificationReviewMasterDocuments"
                                                                            onChange={this.handleNotificationCheckBox}
                                                                            checked={this.state.notificationReviewMasterDocuments}
                                                                        />
                                                                        <label htmlFor="notificationReviewMasterDocuments">Review of Master Documents</label>
                                                                    </FilterCheckBox>
                                                                    <FilterCheckBox themeSettings={themeSettings}>
                                                                        <input
                                                                            type="checkbox"
                                                                            name="notificationFollowUp"
                                                                            id="notificationFollowUp"
                                                                            onChange={this.handleNotificationCheckBox}
                                                                            checked={this.state.notificationFollowUp}
                                                                        />
                                                                        <label htmlFor="notificationFollowUp">Follow Up</label>
                                                                    </FilterCheckBox>
                                                                    <FilterCheckBox themeSettings={themeSettings}>
                                                                        <input
                                                                            type="checkbox"
                                                                            name="notificationOthers"
                                                                            id="notificationOthers"
                                                                            onChange={this.handleNotificationCheckBox}
                                                                            checked={this.state.notificationOthers}
                                                                        />
                                                                        <label htmlFor="notificationOthers">Others</label>
                                                                    </FilterCheckBox>
                                                                </div>
                                                                <div style={{textAlign: 'center', marginTop: '12px'}}>
                                                                    <PageSaveButton themeSettings={themeSettings}
                                                                        onClick={this.saveNotificationSettings} type="button" className="common-save">
                                                                        {this.state.showNotificationBtnLoader ? <div className="loader-btn mt-2"></div> : 'Save'}
                                                                    </PageSaveButton>
                                                                </div>
                                                            </>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        <AlertDialog
                            showAlertDialog={this.state.showAlertDialogInfo}
                            handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                            type={Constants.ALERT_TYPE_ALERT}
                            alertDialogMessage={this.state.alertDialogMessageInfo}
                            proceedBtnClick={this.handleAlertDialogCloseInfo}
                            proceedBtnLabel={ Constants.ALERT_TYPE_OKAY_LABEL }
                            themeSettings={themeSettings}
                        />
                    </section>
                </main>
            </Router>
        )
    }
}
export default UserSetting;